import { identityTranslations as identityTranslationsEn } from '@I18n/en/identity';
import { BoExternalIdentityI } from '@Utils/providers/authProvider';

export const identityTranslations = {
  fields: {
    id: 'Admin ID',
    email: 'Email',
    fullName: 'Nom et prénom',
    companyId: 'Company ID',
    phone_number: 'Numéro de téléphone',
    roles: 'Rôles',
    role_definitions: 'Définitions de rôles',
    auth_role: `Rôle de l'utilisateur`,
    contract_availability: 'Disponibilité des contrats',
    companies: 'Entreprises',
  } satisfies Record<keyof BoExternalIdentityI, string>,
} satisfies typeof identityTranslationsEn;
